import { render, staticRenderFns } from "./quality-report-dialog.vue?vue&type=template&id=1a87042e&scoped=true"
import script from "./quality-report-dialog.vue?vue&type=script&lang=js"
export * from "./quality-report-dialog.vue?vue&type=script&lang=js"
import style0 from "./quality-report-dialog.vue?vue&type=style&index=0&id=1a87042e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87042e",
  null
  
)

export default component.exports